// src/store/slices/clientEntitySlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

interface MonthState {
  selectedMonth: string;
}

const initialState: MonthState = {
  selectedMonth: dayjs().toISOString(),
};

const MonthSlice = createSlice({
  name: 'MonthSlice',
  initialState,
  reducers: {
    setSelectedMonth: (state, action: PayloadAction<string>) => {
      state.selectedMonth = action.payload;
    },
   
  },
});

export const { setSelectedMonth} = MonthSlice.actions;

export default MonthSlice.reducer;
